import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router';

import { Form } from 'libs/forms';
import {
  CheckBoxField,
  FormThemeProvider,
  InputField,
  PasswordField,
  BirthdayField,
} from 'ui/ecosystems/forms';
import { Button } from 'ui';
import { publicApi } from 'api';

import { FormFieldsBlock, TwoInputsGrid, Error } from '../../atoms/forms';
import * as form from '../../../forms/pet-owner-signup';
import { mediaPhone } from '../../../../../ui/styles/media';

export function SignUpPetOwnerForm() {
  const history = useHistory();
  const [error, setError] = useState(null);

  async function handleFormSubmit(values: form.FormState) {
    const data = form.format(values);
    try {
      await publicApi.post('/pet-owner/register', data);
      history.push('/confirm-email/send');
    } catch (e) {
      const error = e.response?.data?.message ?? 'Something wrong';
      setError(error);
    }
  }

  return (
    <Form
      onSubmit={handleFormSubmit}
      schema={form.schema}
      render={({ handleSubmit }) => (
        <FormThemeProvider middle>
          <FormRoot>
            <FormFields>
              <FormFieldsBlock>
                <InputField name="email" placeholder="Email" />
                <TwoFields>
                  <InputField name="firstName" placeholder="First Name" />
                  <InputField name="lastName" placeholder="Last Name" />
                </TwoFields>
                <TwoFields>
                  <InputField
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                  />
                  <InputField name="zipcode" placeholder="Zip Code" />
                </TwoFields>
                <PasswordField name="password" placeholder="Password" />
                <Birthday>
                  <BirthdayWarning>
                    <b>Birthday</b>. To register you must be 18 years of age.  
                  </BirthdayWarning>
                  <BirthdayWarning2>
                    Your birthday will not be displayed.  
                  </BirthdayWarning2>
                  <BirthdayField
                    name="birthday"
                    placeholder="Select Date"
                    minAge={18}
                  />
                </Birthday>
              </FormFieldsBlock>
            </FormFields>
            <Agreement>
              <CheckBoxField name="agree">
                <Message>
                  I agree &nbsp; <a href={'#'}> Terms of Service </a> and
                  <a href={'#'}> Privacy&nbsp;Policy </a>
                </Message>
              </CheckBoxField>
            </Agreement>
            {error && <Error>{error}</Error>}
            <SignUpButton medium onClick={handleSubmit}>
              Sign Up
            </SignUpButton>
          </FormRoot>
        </FormThemeProvider>
      )}
    />
  );
}

const TwoFields = styled(TwoInputsGrid)`
  ${mediaPhone} {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
`;

const FormFields = styled.div`
  display: grid;
  grid-gap: 32px;
  ${mediaPhone} {
    grid-gap: 16px;
  }
`;

const Message = styled.div``;

const BirthdayWarning = styled.div`
  font-size: 14px;
  line-height: 1.5;
`;
const BirthdayWarning2 = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: var(--grayMiddle);
`;

const Birthday = styled.div`
  ${BirthdayWarning} {
    margin-top: 27px;
  }

  ${BirthdayWarning2} {
    margin-bottom: 16px;
  }
`;

const Agreement = styled.div`
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 21px;
`;

const SignUpButton = styled(Button)`
  width: 100%;
`;

const FormRoot = styled.div`
  ${Agreement} {
    margin-top: 34px;
    margin-bottom: 17px;
  }

  ${Error} {
    margin-bottom: 16px;
  }
`;
